// V71.17 — Ekran hata sınırı: sayfa çizilirken hata atarsa beyaz ekran yerine uyarı; hata kendiliğinden
// Sistem › Hata Kayıtları'na bildirilir, kodu gösterilir. `sifirla` değişince (başka sayfa) sınır sıfırlanır.
import React from 'react';
import { hataBildir } from '../utils/hataBildir';

export default class HataSiniri extends React.Component {
  state = { hata: null, kod: null };

  static getDerivedStateFromError(hata) {
    return { hata, kod: null };
  }

  componentDidCatch(hata, bilgi) {
    hataBildir(hata?.message || 'Ekran hatası', [hata?.stack, bilgi?.componentStack].filter(Boolean).join('\n\n'))
      .then(kod => { if (kod && this.state.hata === hata) this.setState({ kod }); });
  }

  componentDidUpdate(onceki) {
    if (this.state.hata && onceki.sifirla !== this.props.sifirla) this.setState({ hata: null, kod: null });
  }

  render() {
    if (!this.state.hata) return this.props.children;
    return (
      <div className="page-container">
        <div className="error-state" role="alert">
          <span>
            ⚠️ Bu ekran açılırken bir hata oluştu ve yöneticiye bildirildi.
            {this.state.kod && <> Hata kodu: <strong>{this.state.kod}</strong></>}
          </span>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => window.location.reload()}>Sayfayı yenile</button>
        </div>
      </div>
    );
  }
}
